import { eachMonthOfInterval, endOfMonth, format } from 'date-fns';

import { cls } from '@/utils/cls';

import { datePosition } from '../utils/date-position';

export type TimelineGridelinesProps = {
  start: Date;
  end: Date;
};

const dateKey = (date: Date) => format(date, 'yyyy-MM-dd');
const percentageRange = (perc: number) => perc; // Math.min(1, Math.max(0, perc));

export function TimelineGridelines({ start, end }: TimelineGridelinesProps) {
  const months = eachMonthOfInterval({ start, end });

  return (
    <div className="absolute inset-0">
      {months.map((month) => {
        const endMonth = endOfMonth(month);

        const startPosition = datePosition(month, start, end);
        const endPosition = datePosition(endMonth, start, end);

        return (
          <div
            key={dateKey(month)}
            className="absolute top-0 flex h-8 items-center justify-start border-l border-gray-300 pl-1"
            style={{
              left: `${percentageRange(startPosition) * 100}%`,
              right: `${percentageRange(1 - endPosition) * 100}%`,
            }}
          >
            <span className="text-sm text-gray-500">
              {format(month, 'MMM yyyy')}
            </span>
            {Array.from({ length: 4 }).map((_, index, arr) =>
              index > 0 ? (
                <div
                  key={index}
                  className={cls(
                    'absolute left-0 h-1.5 w-1/4 self-end border-l border-gray-200',
                    { hidden: index === 0 },
                  )}
                  style={{
                    left: `${(index / arr.length) * 100}%`,
                    width: `${(1 / arr.length) * 100}%`,
                  }}
                />
              ) : null,
            )}
          </div>
        );
      })}
    </div>
  );
}
